import React, {
  FC, ReactNode, useState,
} from 'react';
import styled from 'styled-components';

import { lessThan } from '~/lib/mediaQuery';

interface AccordionProps {
  title: ReactNode;
  content: ReactNode;
  className?: string;
}

export const Accordion:FC<AccordionProps> = ({
  title, content, ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SCAccordion {...props} data-is-open={String(isOpen)}>
      <SCAccordionTitle onClick={() => { setIsOpen((value) => !value); }}>
        <img
          alt="иконка"
          src={
            isOpen
              ? '/icon/landing/im-author/cross.svg'
              : '/icon/landing/im-author/plus-blue.svg'
          }
        />
        { title }
      </SCAccordionTitle>
      <SCAccordionContent>
        { content }
      </SCAccordionContent>
    </SCAccordion>
  );
};

const SCAccordionContent = styled.div`
  display: block;
  position: relative;
  padding-left: 100px;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(24px);
  transition: 
    max-height 0.8s cubic-bezier(0.16, 1, 0.3, 1),
    translateY 0.8s cubic-bezier(0.16, 1, 0.3, 1)  
  ; 
`;

const SCAccordionTitle = styled.div`
  cursor: pointer;
  padding-left: 100px;
  position: relative;

  &:hover {
    * {
      color: var(--primary-color) !important;;
    }

    img {
      filter: unset;
    }
  }

  img {
    position: absolute;
    left: 50px;
    top: 50%;
    transform: translateY(-50%);
    filter: grayscale(1) brightness(0.5);
  }
`;

const SCAccordion = styled.div<{ isOpen?: boolean }>`
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;

  &[data-is-open="true"] {
    ${SCAccordionContent} {
      transform: translateY(0px);
      margin-top: 24px;
      opacity: 1;
      transition: max-height 0.8s, translateY 0.8s;
      max-height: 1024px;
      padding-left: 20px;
    }
  }
  
  ${lessThan('md')} {
    padding-top: 14px;
    padding-bottom: 14px;

    ${SCAccordionTitle} {
      padding-left: 50px;

      img {
        left: 0;
      }
    }
  }

`;
